import { render, staticRenderFns } from "./UserAdminInfokom.vue?vue&type=template&id=2bc13354"
import script from "./UserAdminInfokom.vue?vue&type=script&lang=js"
export * from "./UserAdminInfokom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports